import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import DownPaymentPlanner from "@/pages/DownPaymentPlanner";

export const Route = createFileRoute("/down-payment-planner")({
  head: () => seoHead("/down-payment-planner"),
  component: DownPaymentPlanner,
});
